// ✅ src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';



const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "samsoftixdb.firebaseapp.com",
  projectId: "samsoftixdb",
  storageBucket: "samsoftixdb.appspot.com",
  messagingSenderId: "390974906580",
  appId: "1:390974906580:web:4c27481597fa2147179b41"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);

// ✅ Export both named and default to support all pages
export { db, auth };     // 🔹 Named exports
export default db;       // 🔹 Default export
